import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-pptx-to-pdf',
    imports: [],
    templateUrl: './blog-pptx-to-pdf.component.html',
    styleUrl: './blog-pptx-to-pdf.component.css'
})
export class BlogPptxToPdfComponent {

}
